import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../Layout';
import { showToast } from '../../helpers/customToast';
import { verifyPaymentStatus } from '../../helpers/stripe';
import { WorkshopManager } from '../../helpers/workshop';

const WorkshopPaymentCompletePage = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const verificationAttempted = useRef(false);

    useEffect(() => {
        const verifyPayment = async () => {
            // Skip if verification was already attempted
            if (verificationAttempted.current) {
                return;
            }
            verificationAttempted.current = true;

            try {
                const documentId = searchParams.get('document_id');
                const sessionId = searchParams.get('session_id');

                if (!documentId || !sessionId) {
                    throw new Error('Paramètres manquants');
                }

                // Get reservation details
                const reservation = await WorkshopManager.getReservationByDocumentId(documentId);
                if (!reservation) {
                    throw new Error('Réservation introuvable');
                }

                // Verify payment status
                const paymentStatus = await verifyPaymentStatus(sessionId, documentId);
                
                if (paymentStatus.success) {
                    // Update reservation status
                    await WorkshopManager.updateReservation(reservation.id, {
                        status: 'confirmed'
                    });
                    
                    // Also need to update workshop date to increment participants count
                    if (reservation.workshop_date) {
                        const currentParticipants = reservation.workshop_date.current_participants || 0;
                        await WorkshopManager.updateWorkshopDate(reservation.workshop_date.id, {
                            current_participants: currentParticipants + 1
                        });
                    }
                    
                    // Redirect to confirmation page
                    navigate('/atelier-confirmation', {
                        state: { 
                            reservationId: reservation.id,
                            documentId: documentId,
                            paymentConfirmed: true
                        }
                    });
                } else {
                    throw new Error('Échec de la vérification du paiement');
                }
            } catch (error) {
                console.error('Error verifying workshop payment:', error);
                showToast('Une erreur est survenue lors de la vérification de votre paiement. Veuillez contacter le support.', 'error');
                // Redirect to workshops page after a few seconds
                setTimeout(() => navigate('/ateliers'), 3000);
            } finally {
                setLoading(false);
            }
        };

        verifyPayment();
    }, [searchParams, navigate]);

    if (loading) {
        return (
            <Layout>
                <div className="container my-5">
                    <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Vérification du paiement...</span>
                        </div>
                        <p className="mt-3">Vérification de votre paiement...</p>
                    </div>
                </div>
            </Layout>
        );
    }

    return null;
};

export default WorkshopPaymentCompletePage;